import '../styles/StatusDisplay.css'

function StatusDisplay({ status }) {
  // Only show in debug mode or when there's an issue
  const showStatus = import.meta.env.VITE_DEBUG_MODE === 'true' ||
                     status.includes('error') ||
                     status.includes('failed') ||
                     status.includes('required')

  if (!showStatus) return null

  return (
    <div className="status-display">
      {status}
    </div>
  )
}

export default StatusDisplay